import isomorphicFetch from "isomorphic-fetch";

export default (url, method, body, noHeaders = false) => {
  let options = {
    method,
    body: method !== "GET" ? JSON.stringify(body) : null,
  };

  if (!noHeaders) {
    options.headers = requestHeaders();
  }

  return isomorphicFetch(url, options).then((res) =>
    parseStatus(res.status, res.json())
  );
};

function parseStatus(status, res) {
  return new Promise((resolve, reject) => {
    if (status >= 200 && status < 300) {
      res.then((response) => resolve(response));
    } else {
      res.then((response) => reject({ status, response }));
    }
  });
}

function requestHeaders() {
  const headers = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "asurion-channel": "WEB",
  };

  // Prefer CloudFront origin custom header in deployed envs.
  // Only send from the client when explicitly provided (e.g. local overrides).
  if (process.env.REACT_APP_SLS_API_KEY) {
    headers["x-api-key"] = process.env.REACT_APP_SLS_API_KEY;
  }

  return headers;
}
